import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { ReportTabLayout } from "./ReportTabLayout.js";
import { DifficultyBarChart } from "./DifficultyBarChart.js";
import { TimeAnalysisChart } from "./TimeAnalysisChart.js";
import { QuestionBreakdownTable } from "./QuestionBreakdownTable.js";
import { ScoreSummaryCards } from "./ScoreSummaryCards.js";
import Brain from "../../node_modules/.pnpm/lucide-react@0.309.0_react@18.3.1/node_modules/lucide-react/dist/esm/icons/brain.js";
function AiqIndividualReportView({ data, productName, backButton }) {
  const { summary, questions, byDomain, byDifficulty, timeAnalysis, standardReport, advancedReport, aiqIndexReport, hasPostAiq } = data;
  const improvedCount = questions.filter((q) => q.improved).length;
  return /* @__PURE__ */ jsxs("div", { className: "min-h-screen bg-gray-50", children: [
    /* @__PURE__ */ jsx("div", { className: "bg-linear-to-br from-indigo-600 via-purple-600 to-blue-700 text-white", children: /* @__PURE__ */ jsxs("div", { className: "max-w-5xl mx-auto px-4 py-8", children: [
      backButton && /* @__PURE__ */ jsx("div", { className: "mb-6", children: backButton }),
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-4", children: [
        /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center w-14 h-14 bg-white/20 rounded-2xl", children: /* @__PURE__ */ jsx(Brain, { className: "w-8 h-8" }) }),
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("h1", { className: "text-2xl font-bold", children: "AIQ 성장 리포트" }),
          productName && /* @__PURE__ */ jsx("p", { className: "text-white/80 mt-1", children: productName })
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ jsxs("div", { className: "max-w-5xl mx-auto px-4 py-8 space-y-6", children: [
      /* @__PURE__ */ jsx(
        ReportTabLayout,
        {
          standardReport,
          advancedReport,
          aiqIndexReport,
          hasPostAiq
        }
      ),
      /* @__PURE__ */ jsx("div", { className: "p-4 bg-indigo-50 border border-indigo-200 rounded-xl", children: /* @__PURE__ */ jsxs("p", { className: "text-sm text-indigo-800", children: [
        hasPostAiq && improvedCount > 0 ? `Pre-AIQ에서 틀렸던 문제 중 ${improvedCount}문제를 Post-AIQ에서 맞혔습니다.` : hasPostAiq ? "Pre-AIQ와 Post-AIQ 결과를 비교 분석한 리포트입니다." : "Pre-AIQ 결과를 분석한 리포트입니다. Post-AIQ 완료 후 비교 분석이 가능합니다.",
        summary.preCompletedAt && summary.postCompletedAt && /* @__PURE__ */ jsxs(Fragment, { children: [
          " (",
          new Date(summary.preCompletedAt).toLocaleDateString("ko-KR"),
          " ~ ",
          new Date(summary.postCompletedAt).toLocaleDateString("ko-KR"),
          ")"
        ] })
      ] }) }),
      hasPostAiq && /* @__PURE__ */ jsx(DifficultyBarChart, { data: byDifficulty }),
      hasPostAiq && /* @__PURE__ */ jsx(TimeAnalysisChart, { timeAnalysis, domainData: byDomain }),
      /* @__PURE__ */ jsx(QuestionBreakdownTable, { questions, hasPostAiq }),
      /* @__PURE__ */ jsxs("div", { className: "border-t border-gray-200 pt-6", children: [
        /* @__PURE__ */ jsx("h3", { className: "text-sm font-medium text-gray-400 uppercase tracking-wider mb-4", children: "부록: 단순 정답 개수" }),
        /* @__PURE__ */ jsx(ScoreSummaryCards, { summary })
      ] })
    ] })
  ] });
}
export {
  AiqIndividualReportView
};
//# sourceMappingURL=AiqIndividualReportView.js.map
